<template>
<el-dialog :visible.sync="dialogVisible" top="0" width="565px" :before-close="closeModal">
    <AlertCheckPayment class="d-flex mt-5 mb-2 mx-auto"/>
    <h3 class="c-ndarkthree bold text-center mb-2">
        {{ title }}
    </h3>
    <p class="c-ndarkfour text-center">
        {{ subtitle }}
    </p>
    <span slot="footer" class="dialog-footer d-flex justify-content-end align-items-center">
        <router-link to="" @click.native="saveAndClose"  :class="`${getPrimaryColor} c-ndarkfour mr-4`">
            Salvar e sair
        </router-link>
        <button :class="`btn btn-${getPrimaryColor}`" @click="newPartner" v-if="this.$route.query.new">
            Novo sócio
        </button>
        <button :class="`btn btn-${getPrimaryColor}`" @click="nextPartner" v-else>
            Próximo sócio
        </button>
    </span>
</el-dialog>
</template>

<script>
import AlertCheckPayment from '@/components/icons/AlertCheckPayment'
import getPartners from '@/api/getPartners'
export default {
    components: {
      AlertCheckPayment
    },
    props: {
        dialogVisible: {
            required: true,
            type: Boolean,
            default: false
        },
    },
    data() {
        return {}
    },
    computed: {
        title() {
            if (this.$route.path.includes('procurator')) return 'Procurador cadastrado com sucesso!'
            return 'Sócio cadastrado com sucesso!'
        },
        subtitle() {
            if (this.$route.path.includes('procurator')) return 'O procurador já foi adicionado ao perfil da empresa.'
            return 'O sócio já foi adicionado ao perfil da empresa.'
        }
    },
    methods: {
        closeModal() {
            this.$emit('closeModal', false)
        },
        saveAndClose() {
            this.$emit('closeModal', false)
            //this.$router.push(`/company/register/${this.$route.params.idCNPJ}/message`)
            window.location.href = `${this.getServiceUrls.MARKETPLACE}/home`
        },
        showPartners() {
            this.$emit('closeModal', false)
            this.$router.push(`/company/register/${this.$route.params.idCNPJ}/partner`)
        },
        async nextPartner() {
            await getPartners(this.$route.params.idCNPJ)
            this.$emit('closeModal', false)
            const partner = this.$store.state.register.partners.find(partner => partner.id != this.$route.params.id && (!partner.associateType || partner.associateType != 'Procurador') && partner.registerComplete == 0)
            this.$store.commit('register/setPartner', partner)
            const routePrefix = `/company/register/${this.$route.params.idCNPJ}/partner`
            if (partner.associateType == 'Sócio') return this.$router.push(`${routePrefix}/pf/${partner.id}/0`)
            if (partner.associateType == 'Procurador') return this.$router.push(`${routePrefix}/procurator/${partner.id}/0`)
            else this.$router.push(`${routePrefix}/pj/${partner.id}/0`)
        },
        async newPartner() {
            this.$emit('closeModal', false)
            this.$store.commit('register/resetPartner')
            this.$emit('newUser')
        }
    },
}
</script>

<style>
</style>